export default Backbone.Epoxy.Model.extend({
    defaults: {
        checkInDate: null,
        departureCity: null,
        country: null,
        discount: null,
        hotel: null,
        sortRate: null,
        meal: null,
        nights: null,
        nightsInHotel: null,
        operator: null,
        originalPrice: null,
        price: null,
        priceWithOilTax: null,
        resort: null,
        roomDescription: null,
        routes: null,
        oilTax: null,
        oilTaxIsAbsent: null,
        hotelAvailable: null,
        touristGroup: null,
        transfers: null,
        transfer: null,
        availableTransfers: null,
        lessPlaces: null,
        flightType: null,
        freeCancellation: false,
        promoSegmentId: null,
        block: false,
    },
});